import positions from "./positions";

const setPositionContainerRules = function(ruleSet, position){
    //Attempt to center content horizontally via text-align
    
    if([positions.right, positions.topRight, positions.bottomRight].indexOf(position) !== -1){
        ruleSet.setRule('text-align', 'right');
    }
    
    if([positions.left, positions.topLeft, positions.bottomLeft].indexOf(position) !== -1) {
        ruleSet.setRule('text-align', 'left');
    }

    if([positions.center, positions.bottom, positions.top].indexOf(position) !== -1){
        ruleSet.setRule('text-align', 'center');
    }
};

const setPositionFloat = function(ruleSet, position){
    if([positions.topLeft, positions.left, positions.bottomLeft].indexOf(position) !== -1){
        ruleSet.setRule('float', 'left');
    }

    if([positions.topRight, positions.right, positions.bottomRight].indexOf(position) !== -1){
        ruleSet.setRule('float', 'right');
    }
};

const setPositionRules = function(ruleSet, position, height){
    let topPercentage = 0;

    //Attempt to center horizontally via margin
    if([positions.center, positions.bottom, positions.top].indexOf(position) !== -1){
        ruleSet.setRule('margin-left', 'auto');
        ruleSet.setRule('margin-right', 'auto');
    }
    
    //Center vertically via top
    if([positions.left, positions.center, positions.right].indexOf(position) !== -1){
        //We need to divide by 2 for it to center
        topPercentage = 100 - height;

        //Never attempt to divide by 0 :-)
        if(topPercentage !== 0){
            topPercentage /= 2;
        }
    }

    if([positions.bottomLeft, positions.bottom, positions.bottomRight].indexOf(position) !== -1){
        topPercentage = 100 - height;
    }

    //Ensure we don't exceed 100/go below 0
    topPercentage = Math.min(Math.max(topPercentage, 0), 100);

    if(topPercentage){
        ruleSet.setRule('top', `${topPercentage}%`);
    }
};

export default (settings) => {
    const {
        boldText,
        italicText,
        fontSize,
        font,
        textAlignment,
        textColor,
        backgroundColor,
        borderColor,
        borderRadius,
        position,
        height,
        width,
        marginBottom
    } = (settings || {});
    
    //Sometimes values are nulled, sometimes they simply are not defined
    const isDefined = (value) => value !== null && value !== undefined;
    
    const ruleSet = {
        _internalRuleSet: {},
        setContentPosition(height, position){
            this.setRule('height', `${height}%`);
            setPositionRules(this, position, height);
        },
        setFloatBasedContentPosition(height, position){
            //Certain elements (eg. button) are easier to position with float within the builder
            this.setContentPosition(height, position);
            setPositionFloat(this, position);
        },
        setPositionContainerRules(position){
            setPositionContainerRules(this, position);
        },
        setRule(name, value){
            //In certain cases a rule might be unwanted/have an implementation provided by the caller
            if(value === undefined || value === null){
                delete this._internalRuleSet[name];
                return;
            }
            
            this._internalRuleSet[name] = value;
        },
        toString(){
            const internalRuleSet = this._internalRuleSet;
            
            return Object.keys(internalRuleSet)
                .map(key => `${key}: ${internalRuleSet[key]};`)
                .join(';');
        }
    };
    
    if(boldText) {
        ruleSet.setRule('font-weight', 'bold');
    }
    if(italicText) {
        ruleSet.setRule('font-style', 'italic');
    }
    
    if(isDefined(width)) {
        ruleSet.setRule('width', `${width}%`);
    }
    
    if(isDefined(height)){
        ruleSet.setRule('height', `${height}%`);
        
        if(isDefined(position)){
            ruleSet.setContentPosition(height, position);
        } 
    }
    
    if(isDefined(backgroundColor)) {
        ruleSet.setRule('background-color', backgroundColor);
    }
    if(isDefined(borderColor)) {
        ruleSet.setRule('border-color', borderColor);
    }
    
    if(isDefined(borderRadius)) {
        ruleSet.setRule('border-radius', `${borderRadius}px`);
    }
    
    if(isDefined(fontSize)) {
        ruleSet.setRule('font-size', fontSize);
    }
    if(isDefined(font)) {
        ruleSet.setRule('font-family', font);
    }
    if(isDefined(textAlignment)) {
        ruleSet.setRule('text-align', textAlignment);
    }
    if(isDefined(textColor)) {
        ruleSet.setRule('color', textColor);
    }
    
    if(isDefined(marginBottom)) {
        ruleSet.setRule('margin-bottom', `${marginBottom}px`);
    }

    return ruleSet;
};